import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import {
  Typography,
  makeStyles,
  Link,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    height: 64,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  link: {
    textDecoration: 'underline'
  }
}));

interface Props {
  className?: string,
  openEngagementActions: () => void,
  title: string,
  rootUrl: string,
}

function Toolbar({
  className,
  openEngagementActions,
  title,
  rootUrl,
  ...rest
}: Props) {
  const classes = useStyles();

  return (
    <div
      className={clsx(classes.root, className)}
      {...rest}
    >
      <Link
        to={`${rootUrl}/dashboard`}
        color="inherit"
        component={RouterLink}
      >
        <Typography
          variant="h3"
          color="textPrimary"
        >
          {title}
        </Typography>
      </Link>
    </div>
  );
}

export default Toolbar;
